export default function vipStatus(vip: string) {
  const notVipList = ['0', '14', '15', '16']
  let result = !notVipList.includes(vip) // ? { color: 'orange' } : null
  // console.log('is_vip',result);
  return result
}
